import { gql } from '@lcs/shared/api';

export const deleteCallCostMutation = gql`
   mutation DeleteProviderCallRate($providerCallRateId: Int!) {
      deleteProviderCallRate(id: $providerCallRateId)
   }
`;
